"use client";

/**
 * The asset page's "not found" state. It covers both a slug that never
 * existed and a listing this viewer may not see (draft, in review, private…):
 * `get_asset_detail` answers those the same way to anyone but the seller and
 * staff, so the page can't — and shouldn't — tell them apart.
 */
import Link from "next/link";
import ArrowLeft from "lucide-react/dist/esm/icons/arrow-left";
import { Button } from "@/components/ui/button";

export function PageUnavailable() {
  return (
    <div className="flex items-center justify-center min-h-[60dvh] px-4">
      <div className="text-center max-w-lg w-full">
        <h1 className="font-display text-2xl md:text-3xl font-bold mb-3">Asset not found</h1>
        <p className="text-muted-foreground mb-8 max-w-sm mx-auto">
          This asset doesn&apos;t exist, may have been removed, or the link might be incorrect.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild>
            <Link href="/browse">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Browse Assets
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link href="/">Go Home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
